import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 查询表单绑定值
      form: {
        corpName: null, // 企业名称
        corpCode: null, // 社会信用代码
        economicNum: null, // 资质类型
        agencyCorpLevel: null, // 招标代理等级
      },
      // 查询表单基础数据
      formSearchList: [
        {
          type: "input",
          label: "招标代理机构名称：",
          value: "corpName",
          placeholder: "请输入"
        },
        {
          type: "input",
          label: "社会信用代码：",
          value: "corpCode",
          placeholder: "请输入"
        },
        {
          type: "select",
          label: "资质类型：",
          value: "economicNum",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/BasicDataCombobox",
            zdid: "201507131651150072",
          }
        },
        {
          type: "select",
          label: "招标代理等级：",
          value: "agencyCorpLevel",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/BasicDataCombobox",
            zdid: "201510081604580009",
          }
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "企业名称",
          prop: "corpName",
          isShow: true,
        },
        {
          label: "社会信用代码",
          prop: "corpCode",
        },
        {
          label: "法定代表人姓名",
          prop: "legalMan",
        },
        {
          label: "企业资格等级",
          prop: "economicNumName",
        },
        {
          label: "招标代理等级",
          prop: "agencyCorpLevelName",
        },
        {
          label: "招标代理资格证书号",
          prop: "agencyCorpCertId",
        },
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0,
    }
  },

  // 接收父组件传递的数据
  props: {

  },

  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/corpBasicinfoChoose/agencyChoose", {
        ...this.form,
        ...this.reqPageData,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      })
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
    * 改变每页条数执行的函数
    * @params e 每页条数
    * @author 滕威
    */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 企业选择
     */
    fun_CorpSelect(e) {
      // 回调函数
      this.$nextTick(() => {
        // 赋值父页面交易人企业主键
        this.$parent.form.agencyCorpId = e.val.id;
        // 赋值父页面企业名称
        this.$parent.form.agencyCorpName = e.val.corpName;
        // 赋值父页面交易人企业社会信用代码
        this.$parent.form.agencyCorpCode = e.val.corpCode;
        // 复制父页面法人代表姓名
        this.$parent.form.agencyCorpLegalPerson = e.val.legalMan;
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    },
  }
}